import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Arrow120 } from "@/components/Arrow120";
import { motion } from "framer-motion";

const CreativesSubpage = () => {
  const { category } = useParams();
  const [block, setBlock] = useState(null);
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get(`/subpage_blocks?category=${category}`).then((r) => setBlock(r.data[0]));
    api.get(`/creatives_items?category=${category}`).then((r) => setItems(r.data));
  }, [category]);

  if (!block) {
    return <div className="py-40 text-center text-ahm-teal/60">Loading…</div>;
  }

  return (
    <div data-testid={`subpage-${category}`}>
      <section className="pt-28 md:pt-40 pb-12">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <Link to="/creatives" className="text-sm text-ahm-teal/70 hover:text-ahm-orange uppercase tracking-[0.2em]">← Back to Creatives</Link>
          <h1 className="font-display text-6xl md:text-8xl lg:text-9xl leading-[0.85] text-ahm-teal mt-6 text-balance">
            {block.heading}
          </h1>
          <p className="mt-8 max-w-3xl text-lg md:text-xl text-ahm-teal/85 leading-relaxed">{block.body}</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
            {items.map((it, i) => (
              <motion.div
                key={it.id || i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
                className={`relative overflow-hidden rounded-2xl group bg-ahm-muted ${
                  i % 5 === 0 ? "md:col-span-8 aspect-[16/9]" : "md:col-span-4 aspect-[4/5]"
                }`}
              >
                <img src={it.image} alt={it.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-ahm-teal/80 to-transparent" />
                <div className="absolute bottom-5 left-6 right-6 text-ahm-cream">
                  <h3 className="font-display text-3xl">{it.title}</h3>
                  <p className="text-sm text-ahm-yellow font-mono uppercase tracking-[0.2em] mt-1">{it.subtitle}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 flex flex-col md:flex-row gap-8 items-start md:items-center justify-between">
          <h3 className="font-display text-4xl md:text-5xl text-ahm-teal max-w-2xl">
            Like what you see? Let's build something together.
          </h3>
          <Link to="/contact" className="btn-pill group" data-testid="subpage-contact-cta">
            Start a project
            <Arrow120 />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default CreativesSubpage;
